<ion-app data-cy="Shell">
  <ion-menu contentId="main-content" menu-id="sidebar" type="overlay" ngxAuthUser #loggedUser="userRef">
    <ion-header class="ion-padding" mode="ios">
      <ion-toolbar color="white">
        <ion-buttons slot="end">
          <ion-button (click)="closeMenu()" data-cy="Close menu" mode="ios">
            <ion-ripple-effect role="presentation" class="md unbounded hydrated"></ion-ripple-effect>
            <ion-icon slot="icon-only" color="primary" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>

      <div class="grid grid-menu gap-8">
        <ui-user-profile-image class="avatar" [user]="loggedUser.user" [size]="50"></ui-user-profile-image>

        <div class="flex flex-column gap-4 pt-6 justify-content-center info">
          <div class="fs-16 font-medium">{{ loggedUser.user?.fullName }}</div>
          <div class="fs-15 font-regular">{{ loggedUser.user?.email }}</div>
          <div *ngxAuth="true" class="fs-15 font-regular">{{ role$ | async | role: false:(superOperatore$ | async) }}</div>
        </div>
      </div>
    </ion-header>
    <ion-content>
      <ng-container *ngIf="!showCostCentersList">
        <div class="fs-16 font-medium ion-padding">
          {{ 'sidebar.currentProject' | translate | uppercase }}
        </div>

        <div class="ion-padding-horizontal">
          <ui-project-context-card
            [project]="(selectedProject$ | async) ?? undefined"
            [user]="loggedUser.user"
            [rounded]="true"
            [buyer]="(isBuyerInSelectedProject$ | async) ?? undefined"
            [superBuyer]="(isSuperBuyerInSelectedProject$ | async) ?? undefined"
          ></ui-project-context-card>
        </div>

        <div class="change-project ion-padding-horizontal ion-padding-top">
          <a (click)="toggleCostCentersList()" data-cy="Change cost center">{{ 'sidebar.changeProject' | translate }}</a>
        </div>

        <ion-list lines="full" class="menu-list">
          <ion-item *ngIf="canMakePurchase$ | async" [routerLink]="['/card']" (click)="closeMenu()" detail="false" data-cy="Manage Card">
            <ion-icon name="card-outline" slot="start"></ion-icon>
            <ion-label>{{ 'sidebar.manageCard' | translate }}</ion-label>
          </ion-item>

          <ion-item [routerLink]="['/guide']" (click)="closeMenu()" detail="false" data-cy="Guide">
            <ion-icon name="help-outline" slot="start"></ion-icon>
            <ion-label>{{ 'sidebar.guide' | translate }}</ion-label>
          </ion-item>

          <ion-item (click)="logout()" data-cy="Log out">
            <ion-icon name="exit-outline" slot="start"></ion-icon>
            <ion-label>{{ 'sidebar.logout' | translate }}</ion-label>
          </ion-item>
        </ion-list>
      </ng-container>

      <ng-container *ngIf="showCostCentersList">
        <div class="fs-16 font-medium ion-padding project-title-spacing">
          {{ 'sidebar.selectProject' | translate }}
        </div>
        <ui-cost-centers-list [companies]="loggedUser.user?.companies" (selected)="selectProject($event)"></ui-cost-centers-list>
      </ng-container>
    </ion-content>

    <ion-footer class="ion-padding" mode="ios">
      <div class="text-center w-full" [translate]="'sidebar.appVersion'" [translateParams]="{ version: appVersion }"></div>
      <div class="text-center w-full" [translate]="'sidebar.copyright'" [translateParams]="{ year: currentYear }"></div>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main-content" data-cy="Content"></ion-router-outlet>
</ion-app>
